<ng-container *ngIf="!loginService.isObgyn">
  <app-appointment-setup *ngIf="ApptsByRoom === 'false'"></app-appointment-setup>
  <app-appointments-setup-by-room *ngIf="ApptsByRoom === 'true'"></app-appointments-setup-by-room>
</ng-container>
<ng-container *ngIf="loginService.isObgyn">
  <app-appts-by-room-gyn *ngIf="ApptsByRoom === 'true'"> </app-appts-by-room-gyn>
  <app-appointment-setup *ngIf="ApptsByRoom === 'false'"></app-appointment-setup>
</ng-container>
